import React from "react";
import Countdown from "./Countdown";
import ReserveButton from "./ReserveButton";
import { REGISTRATION_OPENS_LABEL } from "../../config/event";
import { BrandMark } from "../art/Icons";

/** Home-page registration block: a countdown until opening, then "Rezervace otevřena"; one reserve button either way. */
const RegistrationSection = ({ isOpen, timeLeft }) => (
  <section className="registration" id="activities" aria-labelledby="registration-heading">
    <BrandMark className="registration-skull" />
    <span className="kicker">Tvoje místo na druhé straně</span>
    <h2 className="section-title" id="registration-heading">
      Registrace
    </h2>
    {isOpen ? (
      <p className="registration-open">Rezervace otevřena</p>
    ) : (
      <>
        <p className="registration-info">
          Registrace se otevírá <b>{REGISTRATION_OPENS_LABEL}</b>. Do té doby tě do Země vzpomínek pustí jen
          přístupový kód.
        </p>
        <Countdown timeLeft={timeLeft} />
      </>
    )}
    <ReserveButton isOpen={isOpen} className="btn btn-marigold">
      Rezervovat
    </ReserveButton>
  </section>
);

export default RegistrationSection;
